import { useCallback, useEffect, useMemo, useState } from 'react';
import SwiperCore from 'swiper';
import useDisplayComponent from '@/hooks/useDisplayComponent';
import useAuthenticated from '@/hooks/useAuthenticated';
import { scrapGateway } from '@/di-container/common/scrap/gateway/client';
import useSWR from 'swr';
import { Agent } from '@remodeling/shop';

interface UseExpertProfile {
  data: Agent;
}

const useExpertProfile = ({ data }: UseExpertProfile) => {
  const [isOpenConstructionCase, setIsOpenConstructionCase] = useState(false);

  const [SwiperAction, setSwiperAction] = useState<SwiperCore>();
  const [swiper, setSwiper] = useState<SwiperCore>();
  const [isHover, setIsHover] = useState<boolean>(false);

  const { handleNewLink, handleAction } = useDisplayComponent();
  const { isAuthenticated } = useAuthenticated();
  const { getScraps } = scrapGateway();

  const { data: scrapApiResponse, mutate: handleMutateScrapList } = useSWR(
    `scraped_construction_list_by_${data.code}`,
    () => {
      return getScraps.exec({
        scrapTypeCode: 'CONSTRUCTION_CASE',
      });
    },
  );

  const scrapList = useMemo(
    () => scrapApiResponse?.data?.scraps?.content || [],
    [scrapApiResponse?.data?.scraps?.content],
  );

  const handleOpenConstructionCase = useCallback(
    () => setIsOpenConstructionCase(true),
    [],
  );

  const handleCloseConstructionCase = useCallback(
    () => setIsOpenConstructionCase(false),
    [],
  );

  const handleClickNext = useCallback(() => {
    SwiperAction?.slideNext();
  }, [SwiperAction]);

  const handleClickPrev = useCallback(() => {
    SwiperAction?.slidePrev();
  }, [SwiperAction]);

  useEffect(() => {
    if (setSwiperAction && swiper) {
      setSwiperAction(swiper);
    }
  }, [setSwiperAction, swiper]);

  return {
    scrapList,
    handleMutateScrapList,
    isOpenConstructionCase,
    handleNewLink,
    handleAction,
    isAuthenticated,
    handleOpenConstructionCase,
    handleCloseConstructionCase,
    setSwiper,
    isHover,
    setIsHover,
    handleClickNext,
    handleClickPrev,
  };
};

export default useExpertProfile;
